import getFromProcessEnv from 'constants/utils/getFromProcessEnv';

const protocol = getFromProcessEnv('REACT_APP_PROTOCOL');
const deploy = getFromProcessEnv('REACT_APP_DEPLOY');
const domain = getFromProcessEnv('REACT_APP_DOMAIN');

const autenticacaoURL = `${protocol}://auth-server.${domain}/resources/${deploy}/login`;

export default autenticacaoURL;
